#import "../../../../graphql-wrappers/graphql/fragments/edition-fragment.graphql"

mutation ScheduleEdition($edition: EditionScheduleInput!) {
    editionSchedule(input: $edition) {
        edition {
            ...EditionFragment
        }
    }
}
